export const SET_HRMS73E_INDEX_DISP = 'SET_HRMS73E_INDEX_DISP'
export const GET_HRMS73E_INDEX_DISP = 'GET_HRMS73E_INDEX_DISP'
export const SET_HRMS73E_DETAIL_DISP = 'SET_HRMS73E_DETAIL_DISP'
export const GET_HRMS73E_DETAIL_DISP = 'GET_HRMS73E_DETAIL_DISP'
export const GET_HRMS73E_MAX_ROWSPAN = 'GET_HRMS73E_MAX_ROWSPAN'
export const SET_HRMS73E_COLUMNS = 'SET_HRMS73E_COLUMNS'
export const GET_HRMS73E_COLUMNS = 'GET_HRMS73E_COLUMNS'
export const SET_HRMS73E_LABELS = 'SET_HRMS73E_LABELS'
export const GET_HRMS73E_LABELS = 'GET_HRMS73E_LABELS'
export const RECEIVED_HRMS73E_COLUMNS_LABELS = 'RECEIVED_HRMS73E_COLUMNS_LABELS'
export const SET_HRMS73E_INDEX = 'SET_HRMS73E_INDEX'
export const GET_HRMS73E_INDEX = 'GET_HRMS73E_INDEX'
export const SET_HRMS73E_INDEX_SELECTED = 'SET_HRMS73E_INDEX_SELECTED'
export const GET_HRMS73E_INDEX_SELECTED = 'GET_HRMS73E_INDEX_SELECTED'
export const RECEIVED_HRMS73E_INDEX = 'RECEIVED_HRMS73E_INDEX'
export const SET_HRMS73E_DETAIL = 'SET_HRMS73E_DETAIL'
export const GET_HRMS73E_DETAIL = 'GET_HRMS73E_DETAIL'
export const RECEIVED_HRMS73E_DETAIL = 'RECEIVED_HRMS73E_DETAIL'
export const RECEIVED_HRMS73E_DETAIL_FORM = 'RECEIVED_HRMS73E_DETAIL_FORM'
export const TOGGLE_HRMS73E_PAGE = 'TOGGLE_HRMS73E_PAGE'
export const POST_HRMS73E_SAVE = 'POST_HRMS73E_SAVE'
export const POST_HRMS73E_CANCEL = 'POST_HRMS73E_CANCEL'
export const GET_HRMS73E_DISABLE_CODFORM = 'GET_HRMS73E_DISABLE_CODFORM'
export const SET_HRMS73E_DISABLE_CODFORM = 'SET_HRMS73E_DISABLE_CODFORM'



// WEBPACK FOOTER //
// ./src/store/modules/hrms73e/mutation-types.js